import { Card, CardHeader } from './Card';
import { LucideIcon } from 'lucide-react';

interface PageHeaderProps {
  icon: LucideIcon;
  iconColor?: string;
  iconBgColor?: string;
  title?: string;
  description: string;
  count?: number;
  countLabel?: string;
  countColor?: string;
  actions?: React.ReactNode;
}

export function PageHeader({
  icon: Icon,
  iconColor = 'text-blue-600 dark:text-blue-400',
  iconBgColor = 'bg-blue-100 dark:bg-blue-900/30',
  title,
  description,
  count,
  countLabel,
  countColor = 'text-blue-600 dark:text-blue-400',
  actions,
}: PageHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-stretch gap-3">
      <Card className="flex-1">
        <CardHeader className="pb-2 pt-3">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 min-w-0">
              <div className={`w-8 h-8 rounded-lg ${iconBgColor} flex items-center justify-center flex-shrink-0`}>
                <Icon className={`w-4 h-4 ${iconColor}`} />
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400 truncate">
                {description}
              </div>
            </div>
            {count !== undefined && (
              <div className="flex items-center gap-2 whitespace-nowrap flex-shrink-0">
                <span className={`text-2xl font-bold ${countColor}`}>{count}</span>
                {countLabel && (
                  <span className={`text-xs font-medium ${countColor}`}>{countLabel}</span>
                )}
              </div>
            )}
          </div>
        </CardHeader>
      </Card>
      {actions && (
        <div className="flex-shrink-0 flex self-stretch items-stretch">
          {actions}
        </div>
      )}
    </div>
  );
}

